// extracted by mini-css-extract-plugin
export var carrierTab = "_56-0";
export var carrierTabActive = "_56-1 _56-0";
export var carrierTabInactive = "_56-2 _56-0";
export var carrierTabLabel = "_56-3";
export var carrierTabLabelActive = "_56-4 _56-3";
export var carrierTabLabelInactive = "_56-5 _56-3";
export var carrierTabPercentage = "_56-6";
export var carrierTabPercentageActive = "_56-7 _56-6";
export var carrierTabPercentageInactive = "_56-8 _56-6";
export var carrierTabWinnable = "_56-9";
export var carrierTabWinnableActive = "_56-a _56-9";
export var carrierTabWinnableInactive = "_56-b _56-9";
export var comparisonContainer = "_56-d";
export var missingRateButton = "_56-n";
export var missingRateButtonActive = "_56-o _56-n";
export var missingRateButtonInactive = "_56-p _56-n";
export var missingRateButtonLabel = "_56-q";
export var missingRateButtonLabelActive = "_56-r _56-q";
export var missingRateButtonLabelInactive = "_56-s _56-q";
export var sidebar = "_56-c";
export var strategyButton = "_56-e";
export var strategyButtonActive = "_56-f _56-e";
export var strategyButtonDescription = "_56-k";
export var strategyButtonDescriptionActive = "_56-l _56-k";
export var strategyButtonDescriptionInactive = "_56-m _56-k";
export var strategyButtonInactive = "_56-g _56-e";
export var strategyButtonLabel = "_56-h";
export var strategyButtonLabelActive = "_56-i _56-h";
export var strategyButtonLabelInactive = "_56-j _56-h";
export var unitToggleButton = "_56-t";
export var unitToggleButtonActive = "_56-u _56-t";
export var unitToggleButtonInactive = "_56-v _56-t";
export var unitToggleButtonLabel = "_56-w";
export var unitToggleButtonLabelActive = "_56-x _56-w";
export var unitToggleButtonLabelInactive = "_56-y _56-w";